import { formatAssetData } from './asset';

export const colorIdForMap = (equipInsight, selectedCategory) => {
  const forData = formatAssetData(
    equipInsight?.find(o => o.id === selectedCategory)?.assetSum,
  );
  if (forData?.CRITICAL > 0) return { CRITICAL: forData?.CRITICAL };
  if (forData?.URGENT > 0) return { URGENT: forData?.URGENT };
  if (forData?.GOOD > 0 || forData?.PLAN > 0)
    return { 'GOOD-PLAN': forData?.GOOD + forData?.PLAN };
  if (forData?.NODATA > 0) return { NODATA: forData?.NODATA };
  return { 'NOT-CONN': forData?.['NOT-CONN'] };
};

export const colorIdForAllMap = assetSum => {
  const forData = formatAssetData(assetSum);
  const colorIdObj = {};
  if (forData?.GOOD > 0) {
    colorIdObj.GOOD = (colorIdObj?.GOOD || 0) + forData?.GOOD;
  }
  if (forData?.URGENT > 0) {
    colorIdObj.URGENT = (colorIdObj?.URGENT || 0) + forData?.URGENT;
  }
  if (forData?.PLAN > 0) {
    colorIdObj.PLAN = (colorIdObj.PLAN || 0) + forData?.PLAN;
  }
  if (forData?.NODATA > 0) {
    colorIdObj.NODATA = (colorIdObj?.NODATA || 0) + forData?.NODATA;
  }
  if (forData?.['NOT-CONN'] > 0) {
    colorIdObj['NOT-CONN'] =
      (colorIdObj['NOT-CONN'] || 0) + forData?.['NOT-CONN'];
  }
  return colorIdObj;
};

export const createSiteMapGeoJSON = (
  siteList,
  isFilteredSitelist = false,
  selectedCategory = null,
) => {
  const mapArr = siteList?.map(ele => ({
    type: 'Feature',
    geometry: { type: 'Point', coordinates: [ele?.lon, ele?.lat] },
    properties: {
      name: `${ele?.cc}, ${ele?.dn}, ${ele?.ct}, ${ele?.cn}`,
      siteID: ele?.id,
      summary: isFilteredSitelist
        ? colorIdForMap(ele.equipInsight, selectedCategory)
        : colorIdForAllMap(ele?.sum?.[0]?.svcBundleSum?.assetSum),
      coordinates: [ele?.lon, ele?.lat],
    },
  }));
  return {
    type: 'FeatureCollection',
    features: mapArr,
  };
};

export const checkAzureMapHealth = async (azureToken, azureMapClientId) => {
  const url =
    'https://atlas.microsoft.com/search/address/json?api-version=1.0&query=Seattle';
  const headers = {
    Authorization: `Bearer ${azureToken}`,
    'x-ms-client-id': azureMapClientId,
  };
  try {
    const response = await fetch(url, { headers });
    if (response?.ok) {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};
